import { Route } from '@angular/router';
import { PrintRepository, PrintService } from '@softapps/werkstatt/garage-core';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';

export const orderRoutes: Route[] = [
  {
    path: 'order',
    children: [
      {
        path: 'create',
        loadComponent: () =>
          import('./pages/order-form/order-form.component').then(
            (o) => o.OrderFormComponent
          ),
      },
      {
        path: 'edit/:id',
        loadComponent: () =>
          import('./pages/order-form/order-form.component').then(
            (o) => o.OrderFormComponent
          ),
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./pages/order-search/order-search.component').then(
            (o) => o.OrderSearchComponent
          ),
      },
      {
        path: ':id',
        providers: [PrintService, PrintRepository],
        loadComponent: () =>
          import('./pages/order-detail/order-detail.component').then(
            (o) => o.OrderDetailComponent
          ),
      },
      {
        path: '**',
        redirectTo: '/order/search',
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {
      // permission: 'GARAGE.ORDERS',
    },
  },
];
